export const authMutationKeys = {
  completePublicSignupRequest: () =>
    ['complete-public-signup-request'] as const,
  completePasswordResetRequest: () =>
    ['complete-password-reset-request'] as const,
  googleAuthSignin: () => ['google-auth-signin'] as const,
  samlAuthSignin: (authDomain?: string) =>
    ['saml-auth-signin', authDomain ?? 'default'] as const,
  loginRequest: () => ['login-request'] as const,
  publicSignupRequest: () => ['public-signup-request'] as const,
  resendPublicSignupVerificationRequest: () =>
    ['resend-public-signup-verification-request'] as const,
  registerRequest: () => ['register-request'] as const,
  resetPasswordRequest: () => ['reset-password-request'] as const,
};
